<template>
    <table class="table width-100 relative" style="table-layout: fixed ;">
        <tr :key="row.index" v-for="row in rowsEl">
            <td :key="row.index+'-'+column.index" v-for="column in columnsEl"><skeleton :variant="column.variant"></skeleton></td>
        </tr>
    </table>
</template>
<script>
    import Skeleton from "../../Skeleton/Skeleton";

    export default {
        name: 'PlaceholderTable',
        components: {
            Skeleton
        },
        props: {
            columns: {
                type: Number,
                default: 5,
            },
            rows: {
                type: Number,
                default: 3
            }
        },
        computed: {
            rowsEl(){
                let rows = [];
                for(let i = 0; i<this.rows; i++) {
                    rows.push({index: i});
                }
                return rows;
            },
            columnsEl(){
                let rows = [];
                for(let i = 0; i<this.columns; i++) {
                    rows.push({index: i});
                }
                rows[0].variant = "checkbox";
                rows[1].variant = "avatar-squared";
                return rows;
            }
        },
        data () {
            return {

            }
        },
        mounted () {
        },
        methods: {
        }
    }

</script>
<style scoped lang="scss">
</style>

